import { render, staticRenderFns } from "./BpcTableHeader.vue?vue&type=template&id=3dfe48f0&"
import script from "./BpcTableHeader.vue?vue&type=script&lang=js&"
export * from "./BpcTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./BpcTableHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports